/**
 * Why an obligation ended. Mirrors api/Models/ObligationEndReason.cs; order is the order staff see.
 * The server is fail-closed: anything outside this list is a 400, never coerced to a neighbour.
 */
export const OBLIGATION_END_REASONS = [
  'transferred_to_other_provider',
  'business_closed',
  'business_sold',
  'registration_closed',
  'engagement_ended_by_ptc',
  'other',
] as const;

export type ObligationEndReason = (typeof OBLIGATION_END_REASONS)[number];
